import { useMutation } from "@tanstack/react-query";
import userPreferencesService from "../api/userPreferencesService";

export const useUpdateUserPreferences = () => {
  const { updateUserPreferences } = userPreferencesService();

  return useMutation({
    mutationKey: ["update-user-preferences"],
    mutationFn: async ({ userPreferences }) => {
      const response = await updateUserPreferences(userPreferences);
      return response.data;
    },
  });
};
